import gql from 'graphql-tag'

export const isTokenValid = gql`
  query getIsTokenValid($token: String!, $email: EmailAddress!) {
    isTokenValid(input: { token: $token, email: $email })
  }
`
